import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { CampaignService } from '../../services/campaigns/campaign.service';
import { DataService } from 'src/app/core/services/data.service';
import { Papa } from 'ngx-papaparse';
import Swal from 'sweetalert2';
import { ProspectsService } from '../../services/prospects/prospects.service';
import { Observable } from 'rxjs';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { LeadService } from 'src/app/services/lead/lead.service';
import { PROSPECTS_TABLE_POSSIBLE_NAMES } from 'src/app/shared/constants';

export interface Prospect {
	[key: string]: any;
	primary_phone?: string;
	alt_phone?: string;
	company_name?: string;
	address_1?: string;
	address_2?: string;
	city?: string;
	state?: string;
	province?: string;
	zip?: string;
	first_name?: string;
	last_name?: string;
	alt_contact?: string;
	title?: string;
	direct_line?: string;
	ext?: string;
	mobile_phone?: string;
	primary_email?: string;
	employee_sizes?: number;
}

@Component({
	selector: 'app-list-upload',
	templateUrl: './list-upload.component.html',
	styleUrls: ['./list-upload.component.scss'],
})
export class ListUploadComponent implements OnInit {
	@ViewChild('selectFile', { static: true }) selectFile: ElementRef;
	totalProspectsUpload = 0;
	chunkSize = 20;
	loadingFile = false;
	combineOrReplace = 'COMBINE';

	public test = [];
	public ourDB = [
		{ name: 'Title', variable: 'title' },
		{ name: 'First Name', variable: 'first_name' },
		{ name: 'Last Name', variable: 'last_name' },
		{ name: 'Primary Phone', variable: 'primary_phone' },
		{ name: 'Direct Line', variable: 'direct_line' },
		{ name: 'EXT', variable: 'ext' },
		{ name: 'Mobile Phone', variable: 'mobile_phone' },
		{ name: 'Primary Email', variable: 'primary_email' },
		{ name: 'Alt Email', variable: 'alt_email' },
		{ name: 'Address 1', variable: 'address_1' },
		{ name: 'Address 2', variable: 'address_2' },
		{ name: 'City', variable: 'city' },
		{ name: 'State', variable: 'state' },
		{ name: 'Province', variable: 'province' },
		{ name: 'ZIP', variable: 'zip' },
		{ name: 'Alt Contact', variable: 'alt_contact' },
		{ name: 'Alt Phone', variable: 'alt_phone' },
		{ name: 'Company Name', variable: 'company_name' },
		{ name: 'Employee Size', variable: 'employee_size' },
		{ name: 'EIN', variable: 'EIN' },
		{ name: 'Website URL', variable: 'website_url' },
		{ name: 'Business Code', variable: 'business_code' },
		{ name: 'Business Code Description', variable: 'business_code_description' },
		{ name: 'Country Code', variable: 'country_code' },
		{ name: 'Annual Revenue', variable: 'annual_revenue' },
		{ name: 'Plan Assets', variable: 'plan_assets' },
		{ name: 'Plan Participants', variable: 'plan_participants' },
		{ name: 'Provider 1', variable: 'provider_1' },
		{ name: 'Provider 2', variable: 'provider_2' },
		{ name: 'Renewal Month 1', variable: 'renewal_month_1' },
		{ name: 'Renewal Year 1', variable: 'renewal_year_1' },
		{ name: 'Renewal Month 2', variable: 'renewal_month_2' },
		{ name: 'Renewal Year 2', variable: 'renewal_year_2' },
		{ name: 'Additional Info', variable: 'additional_info' },
	];

	formData = new FormData();

	prospectDB: any = {
		primary_phone: '',
		alt_phone: '',
		company_name: '',
		address_1: '',
		address_2: '',
		city: '',
		state: '',
		province: '',
		zip: '',
		first_name: '',
		last_name: '',
		alt_contact: '',
		title: '',
		direct_line: '',
		ext: '',
		mobile_phone: '',
		primary_email: '',
		alt_email: '',
		employee_size: '',
		EIN: '',
		website_url: '',
		business_code: '',
		business_code_description: '',
		country_code: '',
		annual_revenue: '',
		plan_assets: '',
		plan_participants: '',
		provider_1: '',
		provider_2: '',
		renewal_month_1: '',
		renewal_year_1: '',
		renewal_month_2: '',
		renewal_year_2: '',
		additional_info: '',
	};

	// bread crumb items
	breadCrumbItems!: Array<{}>;
	loadingExcel: boolean = false;
	submitted = false;

	public data: any;
	public prospectsArray = [];
	public csvKeys: any = [];
	public arrayPropects: any = [];
	public fileSelected = false;
	campaignId: number;
	campaigns: any[] = [];

	public testmodel = '';
	public loading;

	public posibleNames = PROSPECTS_TABLE_POSSIBLE_NAMES;

	constructor(private papa: Papa, public utils: UtilsService, private dataService: DataService, private campaignService: CampaignService, private prospectsSrv: ProspectsService, private leadSrv: LeadService) {
		this.campaignId = 0;
		this.loading = false;
	}

	ngOnInit(): void {
		this.campaignService.getCampaignsForSelect().subscribe((data: any) => {
			this.campaigns = data.body;
		});
	}

	handleFileSelect(evt: any) {
		this.loadingFile = true;
		var files = evt.target.files; // FileList object
		var file = files[0];
		// Adding file to FormData
		this.formData.append('file', file, file.name);

		var reader = new FileReader();
		reader.readAsText(file);
		reader.onload = (event: any) => {
			var csv = event.target.result; // Content of CSV file

			this.papa.parse(csv, {
				skipEmptyLines: 'greedy',
				header: true,
				complete: (results) => {
					this.data = results.data;
					this.fileSelected = true;
					this.csvKeys = Object.keys(this.data[0]);
				},
			});

			this.csvKeys = this.csvKeys.sort((a, b) => (a < b ? -1 : 1));
			this.prospectDB = this.mapCsvColumnsToProps(this.csvKeys);
		};
	}

	selectFileClick() {
		this.selectFile.nativeElement.click();
	}

	createProspectsObjects() {
		this.data.forEach((csvProspect: { [x: string]: string }) => {
			let prospect: Prospect = {};

			this.ourDB.forEach((columna) => {
				if (
					csvProspect[this.prospectDB[columna.variable]] != undefined
				) {
					if (columna.variable != 'employee_sizes') {
						prospect[columna.variable] =
							csvProspect[this.prospectDB[columna.variable]];
					} else {
						if (
							csvProspect[this.prospectDB[columna.variable]] != ''
						) {
							prospect[columna.variable] = parseInt(
								csvProspect[this.prospectDB[columna.variable]],
							);
						} else {
							prospect[columna.variable] = 0;
						}
					}
				} else {
					if (columna.variable != 'employee_sizes') {
						prospect[columna.variable] = '';
					} else {
						prospect[columna.variable] = 0;
					}
				}
			});

			this.arrayPropects.push(prospect);
		});
	}

	save_prospects() {
		if (this.campaignId === 0) {
			this.utils.swal('Campaign not selected', 'error', 'To continue select a campaign');
			this.loading = false;
			return '';
		} else if (this.posibleNames['primary_phone'] === '') {
			this.utils.swal('Primary Phone is not selected', 'error', 'To continue select a value for primary phone');
			this.loading = false;
			return '';
		}

		this.loading = true;
		this.createProspectsObjects();

		const arrayChunks = [];
		for (let i = 0; i < this.arrayPropects.length; i += this.chunkSize) {
			arrayChunks.push(this.arrayPropects.slice(i, i + this.chunkSize));
		}

		if(this.combineOrReplace == 'REPLACE'){
			this.prospectsSrv.deleteRelatedProspects(this.campaignId).subscribe((data: any)=>{
				arrayChunks.reduce((p, c) => p.then(() => this.saveApiCall(c, this.campaignId)), Promise.resolve());
			});
		} else {
			arrayChunks.reduce((p, c) => p.then(() => this.saveApiCall(c, this.campaignId)), Promise.resolve());
		}
	}

	downloadFileErrors(data: string) {
		const blob = new Blob([data], { type: 'text/csv' });
		const url = window.URL.createObjectURL(blob);
		window.open(url);
	}

	setCampaign(event) {
		if(event == 0){
			this.campaignId = null
		} else {
			this.campaignId = event.id;
		}
	}

	mapCsvColumnsToProps(csvColumns: string[]): any {
		// Inicializa el objeto de destino con valores vacíos
		const mappedObject: any = {
			primary_phone: '',
			alt_phone: '',
			company_name: '',
			address_1: '',
			address_2: '',
			city: '',
			state: '',
			province: '',
			zip: '',
			first_name: '',
			last_name: '',
			alt_contact: '',
			title: '',
			direct_line: '',
			ext: '',
			mobile_phone: '',
			primary_email: '',
			alt_email: '',
			employee_size: '',
			EIN: '',
			website_url: '',
			business_code: '',
			business_code_description: '',
			country_code: '',
			annual_revenue: '',
			plan_assets: '',
			plan_participants: '',
			provider_1: '',
			provider_2: '',
			renewal_month_1: '',
			renewal_year_1: '',
			renewal_month_2: '',
			renewal_year_2: '',
			additional_info: '',
		};

		// Recorre las claves (propiedades) del objeto de mapeo
		for (const prop in this.posibleNames) {
			if (this.posibleNames.hasOwnProperty(prop)) {
				// Encuentra el primer nombre de columna que coincide
				const matchingColumn = csvColumns.find((col) => this.posibleNames[prop].map((x) => x.toLowerCase()).includes(col.toLowerCase()));

				// Si se encuentra una coincidencia, asigna el nombre de la columna
				if (matchingColumn) {
					(mappedObject as any)[prop] = matchingColumn;
				}
			}
		}

		return mappedObject;
	}

	isSelected(key: string) {
		if (Object.values(this.prospectDB).includes(key)) {
			return true;
		} else {
			return false;
		}
	}

	async saveApiCall(arrayPropects: any[], campaignId: number){
		await this.prospectsSrv.uploadProspects(arrayPropects, campaignId).toPromise().then((data: any)=>{
			if (data.body.errors) {
				let errorFiles = '';
				data.body.errors.forEach((error) => {
					errorFiles += error + '\n';
				});
			}
			this.totalProspectsUpload +=this.chunkSize;
			if(this.totalProspectsUpload >= this.arrayPropects.length){
				this.fileSelected = false;
				Swal.fire('Saved!', 'All prospects were saved successfully', 'success');
				this.prospectsSrv.setRelProspectsCampaigns(this.campaignId).subscribe((data: any) => {
					console.info(data);
				});
				this.loading = false;
			}

		});
	}

	onLoadFinish(event: any) {
		this.loadingFile = false;
	}
}
